/**
 * תיאורי board באנגלית מה-API (למשל "Room and Breakfast") — לפני חילוץ קוד/טוקן.
 * @returns {string|null}
 */
function mapEnglishBoardDescriptionToHebrew(s) {
  if (s == null || s === "") return null;
  const low = String(s).toLowerCase().replace(/\s+/g, " ").trim();
  if (!low || !/[a-z]/.test(low)) return null;
  if (/(^|\b)(room\s+and\s+breakfast|bed\s+and\s+breakfast|bed\s*&\s*breakfast)(\b|$)/.test(low)) {
    return "לינה וארוחת בוקר";
  }
  if (/(^|\b)room\s+only(\b|$)/.test(low)) return "לינה בלבד";
  if (/\bhalf\s+board\b/.test(low)) return "חצי פנסיון";
  if (/\bfull\s+board\b/.test(low)) return "פנסיון מלא";
  if (/\ball[\s-]?inclusive\b/.test(low)) return "הכל כלול";
  if (/\bself[\s-]?catering\b/.test(low)) return "הסעדה עצמית";
  if (/\bultra[\s-]?all\b/.test(low) || /\buai\b/.test(low) || /\bual\b/.test(low)) {
    return "הכל כלול מורחב";
  }
  return null;
}

/**
 * תרגום קוד בסיס אירוח מ-LDS לעברית — מקור אחיד ל-mini-site חבילות ולרכיבים קשורים.
 * הערה: BB ממופה כמו ב-VacationPackagesResults היסטורית (מסומן כחצי פנסיון יחד עם HB).
 */
export function getLdsBoardBasisLabelHebrew(boardCode) {
  if (boardCode == null || boardCode === "") return "";
  if (typeof boardCode === "string") {
    const trimmed = boardCode.trim();
    const fromEnglish = mapEnglishBoardDescriptionToHebrew(trimmed);
    if (fromEnglish) return fromEnglish;
  }
  const raw =
    typeof boardCode === "string" ? boardCode.trim().split(/\s+/).pop() : boardCode;
  const token = String(raw);
  const key = token.toUpperCase();
  switch (key) {
    case "BB":
      return "חצי פנסיון";
    case "HB":
      return "חצי פנסיון";
    case "FB":
      return "פנסיון מלא";
    case "AI":
      return "הכל כלול";
    case "UAI":
    case "UAL":
    case "UI":
      return "הכל כלול מורחב";
    case "RO":
      return "לינה בלבד";
    case "SC":
      return "הסעדה עצמית";
    default:
      return token;
  }
}

/** תוויות קצרות ל־chips בסינון תוצאות (BB כארוחת בוקר; כרטיס מחיר עדיין משתמש ב-getLdsBoardBasisLabelHebrew). */
export function getLdsBoardFilterChipLabelHebrew(boardCode) {
  if (boardCode == null || boardCode === "") return "";
  const raw =
    typeof boardCode === "string" ? boardCode.trim().split(/\s+/).pop() : boardCode;
  const token = String(raw);
  const key = token.toUpperCase();
  switch (key) {
    case "RO":
      return "לינה בלבד";
    case "BB":
      return "ארוחת בוקר";
    case "HB":
      return "חצי פנסיון";
    case "FB":
      return "פנסיון מלא";
    case "AI":
      return "הכל כלול";
    case "UAI":
    case "UAL":
    case "UI":
      return "הכל כלול מורחב";
    case "SC":
      return "הסעדה עצמית";
    default:
      return token;
  }
}
